/**
 * TruckPartsReport / "Parts for the Day" — the printable per-tech pickup
 * sheet. PARTS-PICKUP-01 (Seth 2026-09-02): the report, Today → Parts Desk
 * and the tech's phone now share ONE list (features/parts/pickupList.ts):
 * parts read from the call notes + structured Pegasus parts + arrived part
 * tickets + vendor pickup stops + whatever the office adds by hand. The
 * parser that used to live here moved to features/parts/truckParts.ts.
 *
 * History: PARTS-FIX (2026-06-18) read parts straight from each call's
 * dispatch notes instead of a hardcoded kit; the report also used to drop
 * "Pick Up Part" stops by the wrong pseudo-customer (0079253 is "Off Today";
 * pickups are 0079690) — the shared list gets that right.
 */
import { PartsPickupPanel } from "@/features/parts/PartsPickupPanel";

export { extractTruckParts, tuneupType, type PartKind, type TruckPart } from "@/features/parts/truckParts";

export function TruckPartsReport() {
  return <PartsPickupPanel mode="report" />;
}
